var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"codeBlock"},[_c('pre',{class:_vm.languageClass},[_c('code',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }